<template>
    <div class="supplier_photos">

        <v-container>
            <v-row>
                <v-col>
                    <iframe :src="googleMapUrl" style="border: solid;" width="97%" height="400px"></iframe>
                </v-col>
            </v-row>
        </v-container>



        <!--
            パラメータ
            q=住所
            q=緯度,経度 ex. q=35.670821,139.702726
            z=縮尺 0〜23
            t=表示モード m:地図
            hl=ja 言語
        -->

    </div>
</template>
<script>

import BaseView from "../../components/BaseView";

export default {
    mixins:[BaseView],
    components: {

    },
    props: {
      address1: String,
      address2: String,
      address3: String,
    },
    data: () => ({
        isInitialized:false,
        isFetched:false,
        isLoading:false,
        isDownloading:false,

        condition:{},
        pager:{},
        errors:{},
    }),
    computed: {
      googleMapUrl:function(){
        let address = ""
        if (this.address1) address += this.address1
        if (this.address2) address += this.address2
        if (this.address3) address += this.address3

        return "https://maps.google.co.jp/maps?output=embed&q=" + address
      },
    },
    mounted:function() {
        this.setupConditions();
    },
    created:function() {
    },
    watch: {
        '$route':function (to, from) {
            this.setupConditions();
        },
    },
    methods: {
        setupConditions(){

        },

    },

}
</script>